import React, { useEffect } from 'react';
import './BlogsBottomSheet.css';

const BlogsBottomSheet = ({ isOpen, onClose }) => {
    // Prevent scrolling on body when bottom sheet is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    return (
        <>
            <div className={`blogs-overlay ${isOpen ? 'show' : ''}`} onClick={onClose}></div>
            <div className={`blogs-bottom-sheet ${isOpen ? 'show' : ''}`}>
                <div className="blogs-sheet-header">
                    <div className="blogs-drag-handle" onClick={onClose}></div>
                    <button className="blogs-close-btn" onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>
                
                <div className="blogs-sheet-content">
                    
                    {/* Hero Section */}
                    <section className="blogs-hero">
                        <div className="blogs-hero-content">
                            <h1>Our Blogs</h1>
                            <p>Healthy recipes, smart shopping tips, and kitchen guides—curated to support a convenient, 
flavourful, and sustainable lifestyle.</p>
                        </div>
                        <i className="fas fa-leaf blogs-hero-icon"></i>
                    </section>

                    {/* Search & Filter */}
                    <section className="blogs-filter-section">
                        <div className="blogs-search-wrapper">
                            <i className="fas fa-search"></i>
                            <input className="blogs-search-input" placeholder="Search blogs..." type="text"/>
                        </div>
                        <div className="blogs-filter-buttons">
                            <button className="blogs-btn active">All Posts</button>
                            <button className="blogs-btn">Recipes</button>
                            <button className="blogs-btn">Healthy Tips</button>
                            <button className="blogs-btn">Grocery Guides</button>
                            <button className="blogs-btn">Storage Tips</button>
                        </div>
                    </section>

                    {/* Featured Blog Card */}
                    <section className="blogs-featured">
                        <div className="blogs-featured-img-wrapper">
                            <img alt="Fresh vegetable selection" className="blogs-featured-img" src="https://lh3.googleusercontent.com/aida-public/AB6AXuAhy8Y95VRPnk-r-qt6dtUdZSGksmxeXYmoDLB5inh6nL782lFuGfbOmdVKvqBCl2Or8pev_6etZLb7l-fxqjpmFXVxGkzNiHTA1kl9LTCkYUkiOOCGYh864NVH99JhDZ4mo_IWDYdbJcQF4Czgig8xs7b4KjVulkk9u3eAzfkIfCw3lfey2TlHuUEOD3He0_BYT6diMaSTVxidnpzoG1SJ-Vk2iHX7vHkMeHtnH_sjxBTZ6SiI4DDJEMYhtX8DFAV7Q7t6oSsOtfg"/>
                            <div className="blogs-badge">Featured Guide</div>
                        </div>
                        <div className="blogs-featured-content">
                            <div className="blogs-date">
                                <i className="far fa-calendar-alt"></i>
                                <span>Oct 24, 2024</span>
                            </div>
                            <h2>Mastering Your Weekly Meal Prep: A Fresh Start for Urban Professionals</h2>
                            <p>Discover the essential secrets to streamlining your kitchen time without sacrificing nutrition or taste. From storage hacks to pantry staples, we've got you covered.</p>
                            <div className="blogs-featured-actions">
                                <button className="blogs-read-btn">
                                    Read Featured Article <i className="fas fa-arrow-right"></i>
                                </button>
                                <div className="blogs-author">
                                    <div className="blogs-author-icon">
                                        <i className="far fa-user"></i>
                                    </div>
                                    <span>By Chef Maria</span>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Blog Grid */}
                    <section className="blogs-grid-container">
                        <div className="blogs-grid-header">
                            <h3>Latest Articles</h3>
                            <div className="blogs-line"></div>
                        </div>
                        <div className="blogs-grid">
                            
                            {/* Card 1 */}
                            <div className="blogs-card">
                                <div className="blogs-card-img-wrapper">
                                    <img alt="Healthy Salad" className="blogs-card-img" src="https://lh3.googleusercontent.com/aida-public/AB6AXuAsE5pWnG0-RPxGywtkukiLiuHJZ0l59-DY1mZCkQARh_ICctq7k3z2MUOJFoigqM5JiNszIvfvWfsStvk1exxhZ0_c6WSqFcRWLFSRY_861UAlr9FkFQExLYxGcvHHjLUTHv90mzwu7TUNZE2oIpWt97OjLkbLZjW28md21OhlrTjDppLQOKR2A-dwpQTyaUu5iUOCI6FR0NaKRRBhRHam1ySWOHdiuOnav3sXZAdwjbY5D2S7xFYq14HSmdZB4IZfLC-JDdhdw1w"/>
                                    <span className="blogs-card-badge">RECIPES</span>
                                </div>
                                <div className="blogs-card-content">
                                    <div className="blogs-card-date">October 22, 2024</div>
                                    <h4>10 Superfood Salads to Boost Your Morning Energy</h4>
                                    <p>Learn how to combine seasonal greens with high-protein grains for a lunch that keeps you full all day.</p>
                                    <div className="blogs-card-footer">
                                        <div className="blogs-card-author">
                                            <i className="far fa-user"></i>
                                            <span>Elena R.</span>
                                        </div>
                                        <button className="blogs-card-read">
                                            Read More <i className="fas fa-chevron-right"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Card 2 */}
                            <div className="blogs-card">
                                <div className="blogs-card-img-wrapper">
                                    <img alt="Fridge Storage" className="blogs-card-img" src="https://lh3.googleusercontent.com/aida-public/AB6AXuA1C_aKr77iT7rgY9ckdyXKyO-qIq90LdeJuwF2yAPq_XX_dep3IRJEhDbfrKnSVRIJyXHjVGSQ1SyOimLkcv3auZM-Nf2FuN_ey-aOMPmWiBcoyr1WLnAa-jUjdcfIAzyRk3yCc69pTK3czlTlAKIcDuwKlTR_pQ7TsLzTW99-V5hpgNQY3r0dw8yorGLDE2PqHU1xPr7E52BkLMUSaxRcxDDRok3Kpad8ausKtyltHi1Aa2KoGHqKrQm_xlnPDv_9TTrGMb82CZw"/>
                                    <span className="blogs-card-badge">STORAGE TIPS</span>
                                </div>
                                <div className="blogs-card-content">
                                    <div className="blogs-card-date">October 20, 2024</div>
                                    <h4>The Ultimate Guide to Zero-Waste Food Storage</h4>
                                    <p>Reduce your environmental footprint while keeping your produce crisp and fresh for up to two weeks.</p>
                                    <div className="blogs-card-footer">
                                        <div className="blogs-card-author">
                                            <i className="far fa-user"></i>
                                            <span>Mark S.</span>
                                        </div>
                                        <button className="blogs-card-read">
                                            Read More <i className="fas fa-chevron-right"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Card 3 */}
                            <div className="blogs-card">
                                <div className="blogs-card-img-wrapper">
                                    <img alt="Seasonal Veggies" className="blogs-card-img" src="https://lh3.googleusercontent.com/aida-public/AB6AXuCTQxix2GjSoAB72lhuMMod0Rft97-IopLdgt7xVtuM7CLN6b0raV3tZb49bwZhyHiR8Alg3h2AkjzsgDDKfej7uUVO2_zI7VpO4CReXebPO_UxyYqqHhIqrcz5sJSHBd7GveW4rwrPKAjce8_3-2HwERxLpQV9DXUvlJ1Uttg4eOq5O0UEWRmAaA-LU34jXjXeOUy1HiMUVNr9SLlxGnBJjhrAZze84vc65fAAgH9-spikDISnZ0EZA9ccaFBUZ7am1PlcVjxYxZE"/>
                                    <span className="blogs-card-badge">GROCERY GUIDES</span>
                                </div>
                                <div className="blogs-card-content">
                                    <div className="blogs-card-date">October 18, 2024</div>
                                    <h4>What's in Season: The Best Autumn Produce to Buy Now</h4>
                                    <p>From butternut squash to crisp apples, discover the most flavorful and cost-effective picks this month.</p>
                                    <div className="blogs-card-footer">
                                        <div className="blogs-card-author">
                                            <i className="far fa-user"></i>
                                            <span>Sarah J.</span>
                                        </div>
                                        <button className="blogs-card-read">
                                            Read More <i className="fas fa-chevron-right"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </section>

                    {/* Newsletter CTA */}
                    <section className="blogs-newsletter">
                        <div className="blogs-newsletter-text">
                            <h3>Don't miss a beat</h3>
                            <p>Get fresh recipes and storage tips delivered to your inbox every week.</p>
                        </div>
                        <div className="blogs-newsletter-form">
                            <input className="blogs-newsletter-input" placeholder="Enter your email" type="email"/>
                            <button className="blogs-newsletter-btn">Subscribe Now</button>
                        </div>
                    </section>

                </div>
            </div>
        </>
    );
};

export default BlogsBottomSheet;
